module.exports = __webpack_public_path__ + "img/5.bf5e0b96.jpg";